<template>
    <div :class="[
        'loader-overlay',
        themeClass,
        { 'is-active': isActive }
    ]">
        <Loader :is-active="isActive" />
    </div>
</template>

<script>
import ThemeClassMixin from '@/mixins/ThemeClassMixin'

export default {
    mixins: [
        ThemeClassMixin
    ],

    props: {
        isActive: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            themeClassPrefix: 'loader-overlay--'
        }
    }
}
</script>

<style lang="scss">
.loader-overlay {
    @include hide();
    @include position-cover();
    @include transition(.150s);
    background-color: $color-secondary;
    opacity: 0;
    z-index: 2018;

    &--fixed {
        position: fixed;
    }

    &--light {
        background-color: $color-bg-light;
    }

    &.loader-overlay--master {
        z-index: 4050;

        &.is-active {
            opacity: 1;
        }
    }

    .loader {
        @include transition(.150s);
    }

    &.is-active {
        @include show();
        opacity: .718;
    }
}
</style>
